import script from "./RentalItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RentalItem.vue?vue&type=script&setup=true&lang=js"

import "./RentalItem.vue?vue&type=style&index=0&id=6fd1b55e&lang=scss"

const __exports__ = script;

export default __exports__